import { memo } from 'react';

import WebhookIconSVG from '@/assets/webhook-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IWebhookIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={WebhookIconSVG} {...props} />;

export const WebhookIcon = memo(IWebhookIcon) as typeof IWebhookIcon;
